import React, { useState, useEffect } from 'react';
import { $AdminCreate, $AdminUpdateDTO, AdminsVService } from '../../services/keymaster';
import { authProvider } from '../../services/Security';
import { EditModal } from '../shared/EditModal';
import { AddModal } from '../shared/AddModal';
import { TableModal } from '../shared/TableModal';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import { AdminsVService as AdminsV2Service } from '../../services/V2/keymaster';
import { handleError } from '../shared/Functions';
import { OperatorsVService } from '../../services/padre';
import { CustomTable } from '../shared/CustomTable';

export function Admins() {
    const [loading, setLoading] = useState<boolean>(true);
    const [showAdd, setShowAdd] = useState<boolean>(false);
    const [showEdit, setShowEdit] = useState<boolean>(false);
    const [showLogins, setShowLogins] = useState<boolean>(false);
    const [rowData, setRowData] = useState<any>();
    const [canUpdateAdmin, setCanUpdateAdmin] = useState<boolean>(false);
    const [canCreateAdmin, setCanCreateAdmin] = useState<boolean>(false);
    const [canReadUserRoles, setReadUserRoles] = useState<boolean>(false);
    const [operator, setOperator] = useState<any>();
    const [operatorId, setOperatorId] = useState<any>();
    const [token, setToken] = useState<any>();

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if (!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setOperatorId(data?.operatorId)
        setToken(data?.token)
        setLoading(!loading)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        if (!token || !operatorId) return;
        OperatorsVService.operatorsVGetById(operatorId ?? "")
            .then(x => setOperator(x))
            .catch(x => handleError(x))
        let perms = authProvider.getPermissions();
        setCanUpdateAdmin(perms.some((perm: string) => perm === "UpdateAdmin"));
        setCanCreateAdmin(perms.some((perm: string) => perm === "CreateAdmin"));
        setReadUserRoles(perms.some((perm: string) => perm === "ReadUserRole"));
    }, [token])// eslint-disable-line react-hooks/exhaustive-deps

    const handleShowEdit = (row) => {
        setRowData(row)
        setShowEdit(true);
    }

    const handleViewLogins = (row) => {
        setRowData(row)
        setShowLogins(true)
    }

    return (
        <React.Fragment>
            {showAdd &&
                <AddModal
                    setShow={setShowAdd}
                    show={showAdd}
                    setLoading={setLoading}
                    loading={loading}
                    addEndpoint={AdminsVService.adminsVAdminCreate}
                    keys={$AdminCreate.properties}
                    modelName="Admin"
                    parentId={null}
                    parentsParentId={null}
                    parent={operator}
                    parentValues={["operatorId"]}
                    canReadUserRoles={canReadUserRoles}
                    successMessage={null}
                    successCallback={null}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            {showEdit &&
                <EditModal
                    modelId={rowData.id}
                    parentId={null}
                    parentsParentId={null}
                    data={rowData}
                    modelName="Admin"
                    setShow={setShowEdit}
                    setLoading={setLoading}
                    loading={loading}
                    isEdit={true}
                    editEndpoint={AdminsVService.adminsVUpdate}
                    extraEndpoint={null}
                    deleteEndpoint={null}
                    viewKeys={null}
                    editKeys={$AdminUpdateDTO.properties}
                    extraKeys={null}
                    hardDelete={false}
                    canReadUserRoles={canReadUserRoles}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            {showLogins &&
                <TableModal
                    setShow={setShowLogins}
                    parentId={rowData.id}
                    name="Login Attempts"
                    getEndpoint={AdminsVService.adminsVGetLoginAttemptsById}
                    columns={["userId", "result", "details", "ipAddress", "attemptAt"]}
                    columnNames={["User Id", "Result", "Details", "IP Address", "Attempt At"]}
                />}
            <CustomTable
                title="Admins"
                columns={[
                    { title: 'Username', field: 'username', editable: 'never' },
                    { title: 'Name', field: 'name', editable: 'never' },
                    { title: 'Email', field: 'email', editable: 'never' },
                    { title: 'Active?', field: 'isActive', type: 'boolean', editable: 'never' },
                    { title: 'Type', field: 'userType', editable: 'never' },
                    { title: 'Role', field: 'userRole.name', editable: 'never' }
                ]}
                dataEndpoint={query => {
                    return new Promise((resolve, reject) => {
                        if (!operatorId) resolve({
                            data: [],
                            page: query.page,
                            totalCount: 0
                        });

                        else
                            AdminsV2Service.adminsVGetAll({
                                pageNumber: query.page + 1,
                                numberPerPage: query.pageSize,
                                orderBy: query?.orderBy?.field?.toString() ?? "Username",
                                orderByDesc: query.orderDirection === "desc",
                                filters: [{
                                    property: "OperatorId",
                                    value: operatorId
                                }],
                                searchQuery: query.search
                            }).then((x: any) => {
                                setLoading(false);
                                resolve({
                                    data: x.items ?? [],
                                    page: query.page,
                                    totalCount: x.numberOfItems ?? 0
                                });
                            }).catch(x => {
                                reject(x);
                            });
                    });
                }}
                actions={[
                    {
                        icon: 'refresh',
                        tooltip: 'Refresh Data',
                        isFreeAction: true,
                        onClick: () => { setLoading(!loading); },
                    },
                    {
                        icon: () => <AddIcon />,
                        tooltip: 'Add Admin',
                        isFreeAction: true,
                        onClick: () => setShowAdd(true),
                        disabled: !canCreateAdmin
                    },
                    {
                        icon: () => <EditIcon />,
                        tooltip: 'Edit Admin',
                        onClick: (event, row) => handleShowEdit(row),
                        disabled: !canUpdateAdmin
                    },
                    {
                        icon: () => <FingerprintIcon />,
                        tooltip: "View Login Attempts",
                        onClick: (event, row) => handleViewLogins(row)
                    }
                ]}
                refresh={loading} setRefresh={setLoading} dataSet={null} pageSize={15} enablePaging={true}
                districtId={null} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { }}
                hiddenColumnsDisabled={true} tableHeight={"400px"} enableSearch={false} searchPlaceholder={""}
            />
        </React.Fragment>
    )
}